module.exports = __webpack_public_path__ + "static/media/2-VUKS.a4cd102f.mp3";